import React from 'react';
import { Col, Grid, Row } from 'react-bootstrap';
import AdminTaskGroupTable from './admin-task-group-table';

const AdminTask = () => {
  return <div className='base-layout'>
    <section className='layout--header'>
      <Grid>
        <Row className='button-gutter'>
          <Col xs={12}>
            <h1>Administrative Tasks</h1>
          </Col>
        </Row>
      </Grid>
    </section>
    <section id='section--admin-task' className='layout--section'>
      <Grid>
        <Row className='no-gutter sectionHeader'>
          <AdminTaskGroupTable />
        </Row>
      </Grid>
    </section>
  </div>
}

export default AdminTask


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/admin-task-portal/admin-task.js